module.exports = __webpack_public_path__ + "img/dragon-face.bb18ed20.png";